<template>
    <div class="wrap-collapsible">
        <input :id="`collapsible-${input_id}`" 
                class="toggle" type="checkbox" 
                v-bind:checked="checked"
                @change="$emit('change', $event.target.checked)"
        />
        <label :for="`collapsible-${input_id}`" class="lbl-toggle">
          <span><slot name="caption"></slot></span>

          <span class="marker" v-if="checked">−</span>
          <span class="marker" v-else>＋</span>
        </label>
        <div class="collapsible-content">
        <ul class="content-inner">
          <perfect-scrollbar>
            <slot>

            </slot>
          </perfect-scrollbar>
        </ul>
        </div>
    </div>
</template>

<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

let id_gen = 0;

export default {
    name: "collapsible",
    components: {
      PerfectScrollbar
    },

    model: {
      prop: 'checked',
      event: 'change'
    },

    props: {
      checked: Boolean,
    },
    
    mounted() {
      this.input_id = ++id_gen;
    },

    data() {
      return {
        input_id: null,
      }
    },
}
</script>

<style lang="scss" scoped>
.ps {
  max-height: 200px;
}

.wrap-collapsible {
  border-top: 1px solid black;
  // padding-bottom: 1.2rem;

  input[type='checkbox'] {
    display: none;
  }
  
  .lbl-toggle {
    cursor: pointer;
    display: flex;
    justify-content: space-between;

    color: black;
    // border-radius: 0.5rem;
    
  
    padding: 0.5rem;
    // text-align: center;

    // font-size: 0.9em;
    // font-weight: 300;
    transition: all 0.25s ease-out;

    // .marker {
      // float: right;
    // }

    &:hover {
      background: black;
      color: white;
    }
  }
  
  .toggle:checked + .lbl-toggle::before {
    transform: rotate(90deg) translateX(-3px);
  }
  
  .collapsible-content {
    max-height: 0px;
    overflow: hidden;
    transition: max-height .25s ease-in-out;
  }
  
  .toggle:checked + .lbl-toggle + .collapsible-content {
    max-height: 100vh;
  }
  
  .toggle:checked + .lbl-toggle {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  
  .collapsible-content .content-inner {
    // border-bottom-left-radius: 0.75rem;
    // border-bottom-right-radius: 0.75rem;
    padding: .5rem 0.5rem;
  }

  .content-inner {
    // border: 1px solid black;
    // border-top: none;
  }
}

</style>

<style lang="scss">
// allways visible
  .ps__rail-y {
    opacity: 0.6 !important;
  }
</style>